import { useState, useCallback } from 'react'
import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'
import { eosTool } from '@/services/blockchain/eos-tool'
import type { EosAction, TransactionResult } from '@/types'

export function useEosTransaction() {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const transact = useCallback(async (
    actions: EosAction[],
    successMessage?: string,
  ): Promise<TransactionResult | false> => {
    setLoading(true)
    try {
      const result = await eosTool.transact(actions)
      if (result) {
        toast.success(successMessage || t('swap.success'))
      }
      return result
    } finally {
      setLoading(false)
    }
  }, [t])

  return { transact, loading }
}
